import { create } from 'zustand';
import { makeGet } from '../../utils/call-api-endpoint';
import type { Clasificacion } from './clasificacion';

export interface ClasificacionesState {
  current: Clasificacion;
  actives: Clasificacion[];

  cargarActivas: () => Promise<void>;
  cargarPorId: (id: number) => Promise<void>;
}

export const useClasificacionesStore = create<ClasificacionesState>()((set) => ({
  current: {} as Clasificacion,
  actives: [],

  nuevo: () =>
    set({
      current: {} as Clasificacion
    }),
  cargarActivas: async () => {
    const data = await makeGet<Array<Clasificacion>>('/clasificaciones/activas');

    if (data.isFailure) return;

    set({
      actives: data.result
    });
  },
  cargarPorId: async (id: number) => {
    const data = await makeGet<Clasificacion>(`/clasificaciones/${id}`);

    if (data.isFailure) return;

    set({
      current: data.result
    });
  }
}));
